import * as types from "../constants/actionTypes";

const transformProgram = (program) => ({
  id: program.id,
  organizationPaymentConfigurationId: program.payment_configuration_id,
  whitelabelId: program.whitelabel_id,
  name: program.name,
  description: program.description,
  isActive: program.is_active,
  isArchived: program.is_archived,
  startDate: program.start_datetime,
  endDate: program.end_datetime,
  createdByAdminId: program.created_by_admin_id,
  creationDatetime: program.creation_datetime,
  updateDatetime: program.update_datetime,
});

const transformRule = (rule) => ({
  id: rule.id,
  rewardProgramId: rule.reward_program_id,
  name: rule.name,
  triggerType: rule.trigger_type,
  conditions: rule.conditions,
  rewardType: rule.reward_type,
  rewardConfig: rule.reward_config,
  perUserLimit: rule.per_user_limit,
  totalLimit: rule.total_limit,
  cooldownPeriodSeconds: rule.cooldown_period_seconds,
  priority: rule.priority,
  displayTitle: rule.display_title,
  displayMessage: rule.display_message,
  expiresAfterDays: rule.expires_after_days,
  isArchived: rule.is_archived,
  creationDatetime: rule.creation_datetime,
  updateDatetime: rule.update_datetime,
});

const transformClaim = (claim) => ({
  id: claim.id,
  rewardRuleId: claim.reward_rule_id,
  userId: claim.user_id,
  legacyUserId: claim.legacy_user_id,
  phoneNumberHash: claim.phone_number_hash,
  triggerEventId: claim.trigger_event_id,
  triggerContext: claim.trigger_context,
  status: claim.status,
  rewardAmountMinor: claim.reward_amount_minor,
  currency: claim.currency,
  walletTransactionId: claim.wallet_transaction_id,
  expiresAt: claim.expires_at,
  claimedAt: claim.claimed_at,
  isArchived: claim.is_archived,
  creationDatetime: claim.creation_datetime,
  updateDatetime: claim.update_datetime,
});

const initialState = {
  rewardPrograms: null,
  rewardProgramsSuccess: null,
  createRewardProgram: null,
  createRewardProgramSuccess: null,
  updateRewardProgram: null,
  updateRewardProgramSuccess: null,
  rewardRules: null,
  rewardRulesSuccess: null,
  createRewardRule: null,
  createRewardRuleSuccess: null,
  updateRewardRule: null,
  updateRewardRuleSuccess: null,
  rewardClaims: null,
  rewardClaimsSuccess: null,
};

const rewards = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_REWARD_PROGRAMS_REQUEST: {
      return {
        ...state,
        rewardProgramsSuccess: null,
      };
    }
    case types.GET_REWARD_PROGRAMS_SUCCESS: {
      const entities = action.result?.body?.query_response?.entities || [];
      return {
        ...state,
        rewardProgramsSuccess: true,
        rewardPrograms: {
          content: entities.map(transformProgram),
          totalElements: entities.length,
        },
      };
    }
    case types.GET_REWARD_PROGRAMS_FAILURE: {
      return {
        ...state,
        rewardProgramsSuccess: false,
      };
    }

    case types.CREATE_REWARD_PROGRAM_REQUEST: {
      return {
        ...state,
        createRewardProgramSuccess: null,
      };
    }
    case types.CREATE_REWARD_PROGRAM_SUCCESS: {
      return {
        ...state,
        createRewardProgramSuccess: true,
        createRewardProgram: action.result.body,
      };
    }
    case types.CREATE_REWARD_PROGRAM_FAILURE: {
      return {
        ...state,
        createRewardProgramSuccess: false,
      };
    }

    case types.UPDATE_REWARD_PROGRAM_REQUEST: {
      return {
        ...state,
        updateRewardProgramSuccess: null,
      };
    }
    case types.UPDATE_REWARD_PROGRAM_SUCCESS: {
      return {
        ...state,
        updateRewardProgramSuccess: true,
        updateRewardProgram: action.result,
      };
    }
    case types.UPDATE_REWARD_PROGRAM_FAILURE: {
      return {
        ...state,
        updateRewardProgramSuccess: false,
      };
    }

    case types.CLEAR_REWARD_PROGRAM: {
      return {
        ...state,
        createRewardProgramSuccess: null,
        updateRewardProgramSuccess: null,
      };
    }

    case types.GET_REWARD_RULES_REQUEST: {
      return {
        ...state,
        rewardRulesSuccess: null,
      };
    }
    case types.GET_REWARD_RULES_SUCCESS: {
      const entities = action.result?.body?.query_response?.entities || [];
      return {
        ...state,
        rewardRulesSuccess: true,
        rewardRules: {
          content: entities.map(transformRule),
          totalElements: entities.length,
        },
      };
    }
    case types.GET_REWARD_RULES_FAILURE: {
      return {
        ...state,
        rewardRulesSuccess: false,
      };
    }

    case types.CREATE_REWARD_RULE_REQUEST: {
      return {
        ...state,
        createRewardRuleSuccess: null,
      };
    }
    case types.CREATE_REWARD_RULE_SUCCESS: {
      return {
        ...state,
        createRewardRuleSuccess: true,
        createRewardRule: action.result,
      };
    }
    case types.CREATE_REWARD_RULE_FAILURE: {
      return {
        ...state,
        createRewardRuleSuccess: false,
      };
    }

    case types.UPDATE_REWARD_RULE_REQUEST: {
      return {
        ...state,
        updateRewardRuleSuccess: null,
      };
    }
    case types.UPDATE_REWARD_RULE_SUCCESS: {
      return {
        ...state,
        updateRewardRuleSuccess: true,
        updateRewardRule: action.result,
      };
    }
    case types.UPDATE_REWARD_RULE_FAILURE: {
      return {
        ...state,
        updateRewardRuleSuccess: false,
      };
    }

    case types.CLEAR_REWARD_RULE: {
      return {
        ...state,
        createRewardRuleSuccess: null,
        updateRewardRuleSuccess: null,
      };
    }

    case types.GET_REWARD_CLAIMS_REQUEST: {
      return {
        ...state,
        rewardClaimsSuccess: null,
      };
    }
    case types.GET_REWARD_CLAIMS_SUCCESS: {
      const entities = action.result?.body?.query_response?.entities || [];
      return {
        ...state,
        rewardClaimsSuccess: true,
        rewardClaims: {
          content: entities.map(transformClaim),
          totalElements: entities.length,
        },
      };
    }
    case types.GET_REWARD_CLAIMS_FAILURE: {
      return {
        ...state,
        rewardClaimsSuccess: false,
      };
    }

    default:
      return state;
  }
};

export default rewards;
